export enum SearchParamKey {
  CurrentPage = 'currentPage',
  FilterMyProjects = 'filterMyProjects',
  Search = 'search',
  FocusType = 'focusType',
  FocusCase = 'focusCase',
  FocusYear = 'focusYear',
  FocusMultiple = 'focusMultiple',
  FocusInstrument = 'focusInstrument',
  FocusHurdle = 'focusHurdle',
  FocusHurdleTitle = 'focusHurdleTitle',
  FocusSource = 'focusSource',
  FocusPaused = 'focusPaused',
}
